<button
  type="button"
  class="magnifier-launcher"
  [class.magnifier-launcher-active]="isActive()"
  aria-label="Toggle image magnifier"
  [attr.aria-pressed]="isActive()"
  (click)="toggleMagnifier()"
  title="Magnifier"
>
  <svg viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <circle cx="8.5" cy="8.5" r="5.5" stroke="currentColor" stroke-width="1.6" />
    <path d="M13 13L17 17" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
  </svg>
</button>

<div
  class="magnifier-lens"
  [class.magnifier-lens-visible]="isActive() && isLensVisible()"
  [style.left.px]="lensPosition().x"
  [style.top.px]="lensPosition().y"
  [style.width.px]="lensWidth"
  [style.height.px]="lensHeight"
>
  <div class="magnifier-lens-content" #lensContent></div>
</div>
